export const SET_FAVORITES = 'SET_FAVORITES';
export const CHECK_FAVORITE_OFFER = 'CHECK_FAVORITE_OFFER';
export const DELETE_FAVORITE_OFFERS = 'DELETE_FAVORITE_OFFERS';
export const CHECK_ALL_FAVORITE_OFFERS = 'CHECK_ALL_FAVORITE_OFFERS';